module.exports = __webpack_public_path__ + "img/codeTwo.fad19083.jpg";